<template>
  <div>
    <h3>Do you feel more informed about your personal diabetic risk since your initial Diabetic Risk Assessment?</h3>
    <v-form-group class="card-selector" :validator="$v.moreInformedStatus">
      <b-form-radio v-model="survey.moreInformedStatus" name="moreInformed" :value=moreInformedType.Yes>Yes</b-form-radio>
      <b-form-radio v-model="survey.moreInformedStatus" name="moreInformed" :value=moreInformedType.No>No</b-form-radio>
      <b-form-radio v-model="survey.moreInformedStatus" name="moreInformed" :value=moreInformedType.AboutTheSame>About The Same</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import moreInformedType from "enums/more-informed-type";

  export default {
    mixins: [formMixin],
    data() {
      return {
        moreInformedType: moreInformedType,
      };
    },

    validations: {
      moreInformedStatus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      moreInformedStatus() { return this.survey.moreInformedStatus }
    },

    methods: {
      onSubmit() {

      }
    }
  };
</script>